export default "__VITE_ASSET__BgyCHh3J__"